<div class="modal-header">
  <div class="d-flex align-items-center gap-2">
    <i class="far fa-globe"></i>
    <h5 class="modal-title" i18n>Set A Domain</h5>
    <app-page-help articleId="3ijtdxk9oq" videoId="-"></app-page-help>
  </div>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-12">
        <h6 i18n>Free AdvanceCM Domain</h6>
        <p i18n>Choose a subdomain from one of our free domains or setup a custom domain below.</p>
        <div class="d-flex gap-3">
          <mat-form-field2 class="mat-block">
            <span matPrefix>https://</span>
            <input
              type="text"
              matInput
              i18n-placeholder
              placeholder="Specify A Subdomain"
              formControlName="subdomain"
            />
            <mat-error *ngIf="form.get('subdomain').touched && form.get('subdomain').hasError('pattern')">
              <ng-container i18n>Subdomain is invalid</ng-container>
            </mat-error>
            <mat-error *ngIf="form.get('subdomain').touched && form.get('subdomain').hasError('allSpaces')">
              <ng-container i18n>Subdomain cannot be spaces alone</ng-container>
            </mat-error>
          </mat-form-field2>

          <app-select-search
            [items]="domains"
            [ctrl]="form.get('domain')"
            [multiple]="false"
            [inline]="false"
            placeholder="Domain"
            i18n-placeholder
            matTooltip="Select one of the free AdvanceCM domains to use with your website."
            i18n-matTooltip
            matTooltipPosition="above"
          >
          </app-select-search>
        </div>
      </div>
      <div class="col-12">
        <h6 i18n>Custom Domain</h6>
        <p>
          <ng-container i18n
            >You may purchase your own domain and use it with your AdvanceCM website. Simply enter your domain below
            then follow</ng-container
          >&nbsp;<b><a i18n target="_blank" href="https://advance.cm/help/article/3ijtdxk9oq">these instructions.</a></b
          >&nbsp;
          <ng-container i18n>Custom domains require DNS configuration before they are active.</ng-container>
          <br />
          <b *ngIf="data.website.isEngine" i18n>Booking engines require SSL.</b>
        </p>

        <mat-form-field2 class="mat-block">
          <span matPrefix>https://</span>
          <input
            type="text"
            matInput
            i18n-placeholder
            placeholder="Specify A Custom Domain"
            formControlName="customDomain"
          />
          <mat-error *ngIf="form.get('customDomain').touched && form.get('customDomain').hasError('url')">
            <ng-container i18n>Domain is invalid</ng-container>
          </mat-error>
          <mat-error *ngIf="form.get('customDomain').touched && form.get('customDomain').hasError('allSpaces')">
            <ng-container i18n>Domain cannot be spaces alone</ng-container>
          </mat-error>
          <mat-error *ngIf="form.get('customDomain').touched && form.get('customDomain').hasError('allNumbers')">
            <ng-container i18n>Domain cannot be numbers alone</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <app-website-custom-domain-ssl
    [disabled]="!isCustomDomain"
    *ngIf="isSSLEnabled"
    [matTooltip]="
      !isCustomDomain
        ? 'Please enter and save a custom domain before requesting an SSL'
        : 'Request/Edit SSL for your custom domain'
    "
    matTooltipPosition="above"
    [asButton]="true"
    [website]="website"
  ></app-website-custom-domain-ssl>
  <button (click)="onSave(form)" type="button" class="btn btn-secondary-info create-btn" [disabled]="!isFormValid()">
    <i class="cs-icon cs-icon-save"></i> <ng-container i18n>Save</ng-container>
  </button>
</div>
